import { PortalTextCommonImport } from '../Models/Api/strongbox.financialportal';

export const knownAccountingGroupIds = {
    financialStatements: 'financial-statements',
    accountsReceivable: 'accounts-receivable',
    accountsPayable: 'accounts-payable',
    transactions: 'transactions',
}

export type AccountingCollectionGroup = {
    collect: boolean;
    readOnly?: boolean;
    hidden?: boolean;
    name?: string;
    id: string;
}

export function CollectionGroupToName(id: string, commonImportText?: PortalTextCommonImport): string {
    switch (id) {
        case knownAccountingGroupIds.financialStatements:
            return commonImportText?.financialStatements || '';
        case knownAccountingGroupIds.accountsPayable:
            return commonImportText?.accountsPayable || '';
        case knownAccountingGroupIds.accountsReceivable:
            return commonImportText?.accountsReceivable || '';
        case knownAccountingGroupIds.transactions:
            return commonImportText?.transactions || '';
    }

    console.error(`Encountered unknown collection group id in ImportCustomerFinancialsContainer:collectionGroupToName ${id}`);
    return '';
}

/**
 * Creates a reasonable default accounting collection group set.  Generally this would mean that something
 * has gone wrong and we need to fall back to something okay.
 * */
export function DefaultAccountingCollectionGroup(commonText?: PortalTextCommonImport): Map<string, AccountingCollectionGroup> {
    const accountingCollectionGroups = new Map<string, AccountingCollectionGroup>();
    accountingCollectionGroups.set(
        knownAccountingGroupIds.accountsPayable,
        {
            collect: true,
            id: knownAccountingGroupIds.accountsPayable,
            hidden: false,
            name: commonText?.apTransactions || '',
            readOnly: false,
        }
    );
    accountingCollectionGroups.set(
        knownAccountingGroupIds.accountsReceivable,
        {
            collect: true,
            id: knownAccountingGroupIds.accountsReceivable,
            hidden: false,
            name: commonText?.arTransactions || '',
            readOnly: false,
        }
    );
    accountingCollectionGroups.set(
        knownAccountingGroupIds.transactions,
        {
            collect: true,
            id: knownAccountingGroupIds.transactions,
            hidden: false,
            name: commonText?.transactions || '',
            readOnly: false,
        }
    );
    accountingCollectionGroups.set(
        knownAccountingGroupIds.financialStatements,
        {
            collect: true,
            id: knownAccountingGroupIds.financialStatements,
            hidden: false,
            name: commonText?.financialStatements || '',
            readOnly: false,
        }
    );

    return accountingCollectionGroups;
}